const cardBodyStyle = {
  cardBody: {
    padding: "0.9375rem 1.875rem",
    flex: "1 1 auto"
  }
};

export default cardBodyStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/westmorland-lodge-44/components/cardBodyStyle.jsx